<template>

  <div v-if="status != 2">
    <el-dialog title="审核" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form">
        <el-form-item label="平台：" :label-width="formLabelWidth">
          <div class="">{{form.plantform.name}}</div>
        </el-form-item>
        <el-form-item label="订单号：" :label-width="formLabelWidth">
          <div class="">{{form.order_no}}</div>
        </el-form-item>
        <el-form-item label="订单金额：" :label-width="formLabelWidth">
            <el-input v-model="form.order_price" type="number" autocomplete="off"  min="0"></el-input>
        </el-form-item>
        <el-form-item label="兑换积分：" :label-width="formLabelWidth">
            <el-input v-model="form.points" type="number"  autocomplete="off" min="0"></el-input>
            <div class="">选填，如果未填写，则按照订单金额 兑换积分，如果填写，则以填写的为准</div>
        </el-form-item>
        <el-form-item label="审核状态" :label-width="formLabelWidth">
          <div>
            <el-radio v-model="form.status" :disabled="status==1" :label="0">待审核</el-radio>
            <el-radio v-model="form.status" :disabled="status==1" :label="1">审核通过</el-radio>
            <el-radio v-model="form.status" :disabled="status==1"  :label="2">驳回</el-radio>
          </div>
        </el-form-item>
        <div v-if="form.status == 2">
          <el-form-item label="驳回原因" :label-width="formLabelWidth">
            <el-input v-model="form.remark" autocomplete="off"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button v-if="status==0" type="primary" @click="editApplyStatus">确 定</el-button>
      </div>
    </el-dialog>
  </div>

  <div v-else>
    <el-dialog title="驳回原因" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <p>{{ remark }}</p>
    </el-dialog>
  </div>
</template>

<script>
import PointsApi from '@/api/points.js';
export default {
  data() {
    return {
      status: '',
      remark: '',
      order_price: '',
      /*左边长度*/
      formLabelWidth: '120px',
      /*是否显示*/
      dialogVisible: false
    };
  },
  props: ['open_edit', 'form'],
  created() {
    this.dialogVisible = this.open_edit;
    this.status = this.form.status;
    if (this.status == 2) {
      this.remark = this.form.remark;
    }
  },
  methods: {
    /*修改用户*/
    editApplyStatus() {
      let self = this;
      let params = {
        id:this.form.id,
        status:this.form.status,
        remark:this.form.remark,
        order_price:this.form.order_price,
        points:this.form.points,
      };
      PointsApi.auditExchange(params, true)
        .then(data => {
          self.$message({
            message: '操作成功',
            type: 'success'
          });
          self.dialogFormVisible(true);
        })
        .catch(error => {});
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit('closeDialog', {
          type: 'success',
          openDialog: false
        });
      } else {
        this.$emit('closeDialog', {
          type: 'error',
          openDialog: false
        });
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/points/part/dialog/Edit.vue